import React from 'react';
import { createRoot } from 'react-dom/client';
import * as serviceWorker from './registerServiceWorker';

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dropzone/styles.css';
import '@mantine/tiptap/styles.css';

import App from './App';

// Silence all console output in production (app.hellohousing.de)
if (window.location.hostname.includes('app')) {
  Object.keys(console).forEach((method) => {
    if (typeof console[method] === 'function') {
      console[method] = () => {};
    }
  });
}

// Change 'root' back to 'app' here!
const container = document.getElementById('app'); 
const root = createRoot(container);
root.render(<App />);

serviceWorker.unregister();